var api = "https://api.qingcigame.com";

var index = '';

var initialSlide = 0; //设置默认索引为0
var num = 0; //当前播放歌曲的下标
var music = new Howl({
    src: ["//download4.qcplay.com/qcgame-admin/wNiFjUOf9mrfu6Tq2D9vjxbwLcGcPSTU80sZJa5w.mp3"],
    autoplay: true,
    loop: true,
    onplay: function() {
        $('.h-music-box').addClass('music-on'); //开始播放样式
    },
});
var musicCount = 0;

var obj = {
    index: function() {
        function getRequest() {
            var query = window.location.search;
            if (query.indexOf("?") != -1) {
                var str = query.substring(1);
                var strs = str.split("=");
                if (strs[1] == 1) {
                    initialSlide = 1;
                } else if (strs[1] == 2) {
                    initialSlide = 2;
                } else if (strs[1] == 3) {
                    initialSlide = 3;
                } else if (strs[1] == 4) {
                    initialSlide = 4;
                } else if (strs[1] == 5) {
                    initialSlide = 5;
                } else if (strs[1] == 6) {
                    initialSlide = 6;
                }
            }
        };
        getRequest(); //二级页面导航栏跳转
        this.musicPlay(); //音乐播放
        this.preloading(); // 预加载
        this.indexAjax(); // 首页接口请求
        this.jqslideTxtBox(); // 游戏咨询信息切换
        // this.Textlength(28, 25); // 内容字体长度超过40，标题字体长度超过25
        this.videoAndImg(); // 视频和图片预览
        this.indexBind(); // 首页按钮
        this.downloadInfo(); // 下载
        // this.countNum(); //阿里云埋点
        // this.changeIcon(); // 定时修改下载按钮图片
    },
    changeIcon: function() {
        // 北京时间：2025-03-30 23:00:00
        var targetTime = new Date('2026-03-30T23:00:00+08:00').getTime();

        function changeBg() {
            $('.app-btn').css('background-image', 'url("/official/images/pc/apple_btn_2-ffd2719fdb.png")');
            $('.google-btn').css('background-image', 'url("/official/images/pc/and_btn_2-f028809444.png")');
        }

        if (Date.now() >= targetTime) {
            changeBg();
        } else {
            setTimeout(function() {
                if (Date.now() >= targetTime) {
                    changeBg();
                }
            }, targetTime - Date.now());
        }
    },
    // 视听回廊
    galleryList: function() {
        this.jqslideTxtBox(); // 游戏咨询信息切换
        this.videoSwiper(); //视频轮播
        this.wookmarkBind(); // 瀑布流图片
        // this.galleryBind(); //按钮事件
        this.galleryAjax(); //视听回廊接口
    },
    // 首页按钮
    indexBind: function() {
        $('.monitor-btn').on('click', function() {
            var mon_btn = $(this).attr('data-event');
            obj.countNum(mon_btn);
        })

        // 视频播放
        var Media = document.getElementById('media-play');
        $('.video-btn').click(function() {
            music.pause();
            musicCount = 1;
            $('.h-music-box').addClass('ani-pause');

            var _this = $(this);
            var data = _this.attr('data');
            $('.play-popup').fadeIn().find('video').attr('src', data);
            // $('.play-popup').fadeIn().find('.popup_box').html('<iframe width="1297" height="730" src="https://www.youtube.com/embed/eUhK9VLBFfw" title="【公式PV】スマートフォン向けゲーム『カードキャプターさくら：思い出の鍵』6月25日正式サービス開始" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>');
            Media.play();
        });

        // 关闭视频
        $('.video-pop .play-popup-wrapper').click(function(event) {
            $('.popup').fadeOut().find('video').attr('src', '');
            Media.pause();

            // $('.popup').fadeOut().find('.popup_box').html('');

            // music.play();
            // $('.h-music-box').removeClass('ani-pause'); //去除暂时播放样式
            // $('.h-music-box').addClass('music-on'); //开始播放样式
            // musicCount = 0;
        });

        // 关闭弹窗
        $('.popup').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut();
        });

        // 仙剑音画【壁纸】
        $(".wallpaper-box .item img").on('click', function() {
            var _this = $(this);
            var img_url = _this.attr('src');
            $('.wallpaper-wrap').fadeIn();
            $('.wallpaper-wrap img').attr("src", img_url);
        });

        $('.wallpaper-wrap').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut();
            setTimeout(() => {
                $('.wallpaper-wrap img').attr("src", '');
            }, 300)
        });
    },
    downloadInfo() {
        // 下载地址
        var ios_url = 'https://apps.apple.com/jp/app/%E3%82%AB%E3%83%BC%E3%83%89%E3%82%AD%E3%83%A3%E3%83%97%E3%82%BF%E3%83%BC%E3%81%95%E3%81%8F%E3%82%89-%E6%80%9D%E3%81%84%E5%87%BA%E3%81%AE%E9%8D%B5/id6754003671';
        var google_url = 'https://play.google.com/store/apps/details?id=com.karaq.sakura.jp';

        // 开放时间：日本时间 2026/03/20 09:30:00（JST = UTC+9）
        var openTime = new Date('2026-03-20T09:30:00+09:00').getTime();

        // 下载按钮
        $('.app-btn').attr('href', ios_url);
        $('.google-btn').attr('href', google_url);

        // 充值按钮暂未开放
        $('.top-up-btn , .pay-btn').on('click', function(e) {
            window.location.href = $(this).attr('href');
            // var now = Date.now();
            // var isGoogleBtn = $(this).hasClass('google-btn');

            // // google-btn 到日本时间开放后可正常跳转
            // if (isGoogleBtn && now >= openTime) {
            //     return true;
            // }

            // // 其他情况都拦截并提示
            // e.preventDefault();
            // e.stopPropagation();
            // layer.msg("現在準備中です 。<br>公開まで今しばらくお待ちください 。", { time: 2000 });
        })
    },
    // 网站音乐
    musicPlay: function() {
        // 检查本地缓存是否有关闭音乐的记录
        var musicStatus = localStorage.getItem('musicStatus');

        if (musicStatus === 'off') {
            // 如果上次用户关闭过音乐，则不自动播放
            music.pause();
            $('.h-music-box').addClass('ani-pause'); //显示为暂停图标
            musicCount = 1;
        } else {
            // 默认自动播放
            music.play();
            $('.h-music-box').removeClass('ani-pause');
            $('.h-music-box').addClass('music-on');
            musicCount = 0;
        }

        // 点击音乐
        $('.h-music-box').click(function(event) {
            if (musicCount == 1) {
                music.play();
                $(this).removeClass('ani-pause'); //去除暂时播放样式
                $(this).addClass('music-on'); //开始播放样式
                musicCount = 0;
                // 播放状态保存
                localStorage.setItem('musicStatus', 'on');
            } else {
                music.pause();
                $(this).removeClass('music-on').addClass('ani-pause'); //添加暂时播放样式
                musicCount = 1;
                // 暂停状态保存
                localStorage.setItem('musicStatus', 'off');
            }
        });
    },
    showSwiper: function() {
        var showSwiper = new Swiper('.swiper-container-show', {
            loop: true,
            direction: 'vertical',
            paginationClickable: true,
            // grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            // noSwiping: true,
            autoplay: 2000,
            spaceBetween: 100,
            autoplayDisableOnInteraction: false,
            navigation: {
                nextEl: '.swiper-button-next2',
                prevEl: '.swiper-button-prev2',
            },
            speed: 500,
            on: {
                init: function(swiper) {
                    swiperAnimate(this);
                    // swiper.stopAutoplay();

                    function Ani(btn, page) {
                        $(btn).on('click', function() {
                            showSwiper.slideTo(page, 500, true);
                            $('.show-click-box li').removeClass("select");
                            $(this).parent().addClass('select');
                        });
                    };

                    function showLink() {
                        for (var i = 10; i >= 0; i--) {
                            Ani('.show-click-box .s' + i, i - 1);
                        };
                    }
                    showLink();

                },
                slideChangeTransitionStart: function(swiper) {
                    // console.log(this.realIndex);
                    $('.show-click-box li').removeClass("select");
                    $('.show-click-box .s' + (this.realIndex + 1)).parent().addClass('select');
                },
            }
        });
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                // console.log(parseInt(e.progress * 100) + '%');
                $(".process-track .process-inner").width(parseInt(e.progress * 100) + '%');
                $(".process-percent #percent").html(parseInt(e.progress * 100));
            };
            // var numbers = e.progress * 100;
        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.index').addClass('index-show');

            setTimeout(function() {
                obj.indexSwiper();
                $('#preloading').remove();
            }, 300)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '/official/images/pc/header_bg-3da311ec22.png',
            '/official/images/pc/code_img-c4a28ac313.png',
            '/official/images/pc/apple_btn-3c15f59390.png',
            '/official/images/pc/and_btn-8ff11a09bb.png',
            '/official/images/pc/banner_bg-659dda281d.png',
            '/official/images/pc/music_btn-ccf764d9ad.png',
            '/official/images/pc/index_bg-0b3eee55c8.png',
            '/official/images/pc/video_play_btn-4c5cacc7cd.png',
            '/official/images/pc/video_btn1-5d223f9607.png',
            '/official/images/pc/video_btn2-e7d1937172.png',
            '/official/images/pc/btn_line_bg-02c9b10ef2.png',
        ]);
    },
    // 首页接口请求
    indexAjax: function() {
        var _this = this;

        // 关注我们地址
        var x_url = 'https://x.com/ccsakuraomokagi'
        var ins_url = 'https://www.instagram.com/ccsakura_omokagi/';
        var line_url = 'https://lin.ee/5tOEM8F';
        var tt_url = 'https://www.tiktok.com/@ccsakura_omokagi';
        var youtube_url = 'https://www.youtube.com/@ccsakura_omokagi';
        var discord_url = 'https://discord.com/invite/bzfg6XEfPK';

        // var fb_url = 'https://www.facebook.com/profile.php?id=61569917674717';
        var pay_url = 'https://pay.karaqgames.com/pay?gameId=131&officialSettingId=13'; // 充值平台地址

        // 关注我们按钮
        $('.twitter-btn').attr('href', x_url);
        $('.ins-btn').attr('href', ins_url);
        $('.line-btn').attr('href', line_url);
        $('.tiktok-btn').attr('href', tt_url);
        $('.youtube-btn').attr('href', youtube_url);
        $('.discord-btn').attr('href', discord_url);

        // $('.facebook-btn , .fb-gz-btn').attr('href', fb_url);
        // 充值平台按钮
        $('.pay-btn , .top-up-btn').attr('href', pay_url);

        _this.showSwiper(); //套装展示轮播
    },
    // 首页轮播
    indexSwiper: function() {
        var mySwiper = new Swiper('.swiper-container', {
            pagination: '.swiper-pagination',
            direction: 'vertical',
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 0,
            mousewheel: true,
            resistanceRatio: 0,
            initialSlide: initialSlide,
            touchMoveStopPropagation: false,
            touchStartForcePreventDefault: true,
            on: {
                init: function() {
                    swiperAnimateCache(this); // 隐藏动画元素
                    swiperAnimate(this); // 运行动画

                    function Ani(btn, page) {
                        $(btn).on('click', function() {
                            mySwiper.slideTo(page, 1000, true);
                        });
                    };

                    function navLink() {
                        for (var i = 6; i >= 0; i--) {
                            Ani('.nav-link-0' + i + ' .link-a', i);
                        };
                    }
                    navLink();

                    var aniLink01 = Ani('.arrow-b', '1');
                    var aniLink02 = Ani('.arrow-b2', '2');
                    var aniLink03 = Ani('.arrow-b4', '3');
                    var aniLink04 = Ani('.arrow-b5', '4');
                    var aniLink05 = Ani('.arrow-b6', '5');
                },
                slideChangeTransitionEnd: function() {
                    swiperAnimate(this); // 每次切换后运行当前动画
                },
                transitionStart: function() {
                    swiperAnimate(this);
                    $('.nav-link').removeClass('on')
                    $('.nav-link-0' + this.activeIndex + '').addClass('on');
                },
            },
        });

        var newsSwiper = new Swiper('.swiper-container-news', {
            loop: true,
            paginationClickable: true,
            pagination: {
                el: '.swiper-pagination2',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 'auto',
            // autoplay: 4000,
        });

        // 公益活动
        var charitySwiper = new Swiper('.swiper-container-charity', {
            loop: true,
            paginationClickable: true,
            pagination: {
                el: '.swiper-pagination3',
                clickable: true,
                renderBullet: function(index, className) {
                    switch (index) {
                        case 0:
                            text = '壹';
                            break;
                        case 1:
                            text = '贰';
                            break;
                        case 2:
                            text = '叁';
                            break;
                        case 3:
                            text = '肆';
                            break;
                    }
                    return '<span class="' + className + '">' + text + '</span>';
                },
            },
            noSwiping: true,
            // autoplay: true,
            autoplayDisableOnInteraction: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            observer: true,
            observerParents: true,
            speed: 500,
            onInit: function(swiper) {
                swiperAnimate(swiper);
                swiper.stopAutoplay();
            },
        });

        // 游戏特色
        function featureSwiper() {
            var charitySwiper = new Swiper('.swiper-container-feature', {
                loop: true,
                paginationClickable: true,
                pagination: {
                    el: '.swiper-pagination4',
                    clickable: true,
                },
                noSwiping: true,
                // autoplay: true,
                autoplayDisableOnInteraction: false,
                navigation: {
                    nextEl: '.swiper-button-next3',
                    prevEl: '.swiper-button-prev3',
                },
                initialSlide: 5,
                speed: 500,
                on: {
                    slideNextTransitionStart: function() {
                        $('.xk-wrap .hand').removeClass('h-next').addClass('h-prev')
                    },
                    slidePrevTransitionStart: function() {
                        $('.xk-wrap .hand').removeClass('h-prev').addClass('h-next')
                    }
                },
            });
            $('.xk-wrap .hand').on('animationend', function() {
                $(this).removeClass('h-next');
                $(this).removeClass('h-prev');
            })
        }
        featureSwiper();
    },
    // 视频轮播
    videoSwiper: function() {
        function videoSwiper() {
            videoSwiper = new Swiper('.swiper-container-video', {
                loop: true,
                direction: 'vertical',
                // spaceBetween: 5.66,
                loopedSlides: 'auto',
                slidesPerView: 'auto',
                observer: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
                speed: 300,
                // nextButton: '.swiper-button-next2',
                // prevButton: '.swiper-button-prev2',
                onInit: function(swiper) {
                    swiper.slideTo(pageIndex === 1 ? imgIndex : videoIndex, 0, true);

                    // 当轮播点击的时候做的操作
                    // $(".img-box img").on('click', function(event) {
                    //     var _this = $(this);
                    //     var dataSrc = _this.attr('src');
                    //     // 替换上半部分显示的图的路径
                    //     $('.art img').attr("src", dataSrc);
                    // })

                    // 开放视频
                    // $(".videos-box img").on('click', function(event) {
                    //     var data = $(this).parent().parent().attr('data');
                    //     var _this = $(this);
                    //     var dataSrc = _this.attr('src');
                    //     // 替换上半部分显示的图的路径以及播放路径
                    //     $('.videos img').attr("src", dataSrc);
                    //     $('.videos a').attr("data", data);
                    // })

                    // 暂未开放视频
                    // $(".videos-box img").on('click', function(event) {
                    //     layer.msg("Coming soon. Please stay tuned!", { time: 2000 });
                    // })
                },
                onSlideChangeEnd: function(swiper) {
                    swiperAnimate(swiper);
                },
                onTouchEnd: function(swiper) {
                    swiperAnimate(swiper);
                },

            });
        };
        videoSwiper();
    },
    wookmarkBind: function() {
        var articleList = [
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/53.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/54.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/55.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/56.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/52.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/2.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/3.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/4.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/5.jpg' },
            // { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/3.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/6.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/7.jpg' },
            // { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/4.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/8.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/9.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/10.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/11.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/12.jpg' },
            // { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/7.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/13.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/8.jpg' },
            // { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/9.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/14.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/15.jpg' },
            // { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/10.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/16.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/17.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/18.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/19.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/20.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/21.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/22.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/23.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/24.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/25.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/26.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/27.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/28.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/29.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/30.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/31.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/32.jpg' },
        ];
        $.each(articleList, function(index, values) {
            var dtHtml = '<li class="grid-item">' +
                '<img src=' + values.thumbnail + '>' +
                '</li>';
            $('#tiles').append(dtHtml);
        });

        $('#tiles').imagesLoaded(function() {
            var options = {
                itemWidth: 200,
                autoResize: true,
                container: $('#tiles'),
                offset: 15,
                outerOffset: 0,
                flexibleWidth: 285
            };
            var handler = $('#tiles li');
            handler.wookmark(options);
        });

        setTimeout(() => {
            $('.htmleaf-box').addClass('htmleaf-box-show');
        }, 1000);
    },
    // 游戏咨询&游戏攻略信息切换
    jqslideTxtBox: function() {
        jQuery(".slideTxtBox").slide({ effect: "left", trigger: "click", easing: "swing" });
        jQuery(".slideTxtBox-02").slide({ effect: "left", trigger: "click", easing: "swing" });
        jQuery(".gallery-list .main").slide({ effect: "left", trigger: "click", easing: "swing" });
    },
    // 视听回廊按钮事件
    galleryBind: function() {
        // 三个页面切换 初始化
        let page_id = this.getQueryVariable('page_id');
        $('.gallery-list .li-0' + page_id + '').addClass('on').siblings().removeClass('on');
        var btn = $('.gallery-list .li-0' + page_id + '');
        setTimeout(function() {
            btn.click();
        }, 300);

        // 视听回廊切换
        $('.gallery-list .hd li').click(function() {
            Media.pause();
            $('.record-player , .h-music-box').addClass('ani-pause'); //添加暂时播放样式
            $('.record-rocker').addClass('rocker-pause'); //添加暂时播放样式
            $('.music-box .play-box .play-btn').addClass('ani-pause'); //添加暂时播放样式
        });

        var Media = document.getElementById('media-play');
        // 媒体视频播放
        $('.video-btn').on('click', function(event) {
            var _this = $(this);
            $('.thumbnail-img').fadeOut(); //视频展示图
            $('.video-show-box video').fadeIn(); //视频
            $('.video-btn-box').fadeOut(); //视频按钮
            Media.play(); //播放
        });

        // 视频预览
        $('.swiper-container-video .videos-box').on('click', 'a', function() {
            var _this = $(this).find('img');
            var img_src = _this.attr('src');
            var video_src = _this.attr('data');
            var video_title = _this.attr('title');

            $(this).parent().addClass("on");
            $(this).parent().siblings().removeClass("on");
            // $('.thumbnail-img').fadeIn();
            // $('.video-btn-box').fadeIn();
            $('.video-show-box video').show();

            $('.thumbnail-img').find('img').attr('src', img_src); //图片填充
            $('.video-show-box').find('video').attr('src', video_src); //视频填充
            $('#videoName').html(video_title); //视频标题填充
            Media.play(); //播放
            $('.thumbnail-img').fadeOut();
            $('.video-btn-box').fadeOut();
        })

        // 歌曲选择按钮
        $('.select-btn').click(function(event) {
            $(".music-select-wrap").fadeIn();
        });

        // 点击背景关闭弹窗
        $('.music-select-wrap').click(function(event) {
            if ($(event.target)[0] == $(this)[0]) {
                $(this).fadeOut();
            }
        });
    },
    // 视听回廊接口
    galleryAjax: function() {
        var _this = this;
        music.pause();
        $.ajax({
            url: api + "/web/article?cate_id=117&page=1&game_id=131",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var video = json.data.articleList.data; //视频

                    // 【游戏视频】
                    if (video.length !== 0) {
                        $(".video-show-box .thumbnail-img img").attr("src", video[0].thumbnail);
                        $(".video-show-box video").attr("src", video[0].video_link);
                        $(".content-box #videoName").html(video[0].article_title);
                    }

                    $('.content-box #videoName').each(function() {
                        if ($(this).text().length > 21) {
                            var str = $(this).text();
                            $(this).text(str.substr(0, 21) + '...');
                        }
                    });

                    $.each(video, function(index, values) {
                        var videoHtml = `<div class="swiper-slide videos-box">
                                <a href="javascript:;">
                                    <img src="${values.thumbnail}" data="${values.video_link}" title="${values.article_title}" alt="">
                                    <i></i>
                                    <b class="ani-btn"></b>
                                </a>
                            </div>`;
                        $('.swiper-container-video .slideVideoBox').append(videoHtml);
                    })
                    $('.swiper-container-video .slideVideoBox').children(':eq(0)').addClass('on');

                    _this.galleryBind();
                } else {
                    layer.msg("サーバ要求に失敗しました", { time: 2000 });
                }
            },
            error: function() {
                layer.msg("サーバ要求に失敗しました", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 内容字体长度超过40，标题字体长度超过25
    Textlength: function(x1, x2) {
        $('.slideTxtBox .bd p').each(function() {
            // console.log($(this).text().length);
            if ($(this).text().length > x1) {
                var str = $(this).text();
                $(this).text(str.substr(0, x1) + '...');
            }
        });
        $('.slideTxtBox .bd h2').each(function() {
            // console.log($(this).text().length);
            if ($(this).text().length > x2) {
                var str = $(this).text();
                $(this).text(str.substr(0, x2) + '...');
            }
        });
    },
    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    // 视频和图片预览
    videoAndImg: function() {
        // 关闭视频 & 其他弹窗
        $('.popup').on('click', '.close-btn', function(event) {
            $('.video-wrap, .popup-video').fadeOut();
            $('.popup').fadeOut();
        });

        // 点击视频浏览
        $('.cartoon-ul').on('click', '.li-sp', function(event) {
            var _this = $(this);
            $('.video-wrap, .popup-video').fadeIn().find('iframe').attr('src', _this.find('img').attr('data')).removeClass('ani-btn');
        });

        $('.cartoon-ul').on('click', '.li-03', function(event) {
            $('.video-wrap, .popup-video').fadeIn();
        });
    },
    // 首页轮播
    s: function() {
        var newsSwiper = new Swiper('.swiper-container-news', {
            loop: true,
            paginationClickable: true,
            pagination: '.swiper-pagination2',
            slidesPerView: 'auto',
            autoplay: 4000,
        });
        //鼠标覆盖停止自动切换
        newsSwiper.container[0].onmouseover = function() {
            newsSwiper.stopAutoplay();
        };
        //鼠标移出开始自动切换
        newsSwiper.container[0].onmouseout = function() {
            newsSwiper.startAutoplay();
        };

        // 公益活动
        var charitySwiper = new Swiper('.swiper-container-charity', {
            loop: true,
            paginationClickable: true,
            pagination: '.swiper-pagination3',
            noSwiping: true,
            autoplay: 2000,
            autoplayDisableOnInteraction: false,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            effect: 'coverflow',
            centeredSlides: true,
            slidesPerView: 'auto',
            loopedSlides: '4',
            observer: true,
            observerParents: true,
            initialSlide: 3,
            speed: 700,
            coverflow: {
                rotate: -30, // 旋转的角度
                stretch: 5, // 拉伸   图片间左右的间距和密集度
                depth: 30, // 深度   切换图片间上下的间距和密集度
                modifier: 10, // 修正值 该值越大前面的效果越明显
                // slideShadows : false// 页面阴影效果
            },
            onInit: function(swiper) {
                swiperAnimate(swiper);
                swiper.stopAutoplay();
            },
        });
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    }
}